import {AjaxPagination} from "../AjaxPagination";
import {fetchPage} from "../../util/ajax";
import {getParent} from "../../util/dom";
import {createLogger} from "../../util/logger";
import {Notifications} from "../Notifications";
import {createElement} from "../../util/html";

const console = createLogger("InvitationsTable");

export class InvitationsTable extends AjaxPagination {
    static name = "invitations-table";

    get name() {
        return InvitationsTable.name;
    }

    constructor(el, props) {
        super(el);

        /**
         * Search Form
         * @type {HTMLFormElement}
         */
        this.$searchForm = this.$("searchForm");

        /**
         * Element that contains content that is replaced by ajax
         * @type {HTMLElement|HTMLElement[]|null}
         */
        this.$content = this.$("content");

        /**
         *
         * @type {HTMLTableElement}
         */
        this.$table = this.$("table");

        this.addEventListener(this.$table, "submit", this.onSubmitRevoke.bind(this));
        this.addEventListener(this.$searchForm, "submit", this.onSubmitSearch.bind(this));

        console.log(this);
    }

    /**
     *
     * @param {SubmitEvent} e
     */
    onSubmitSearch(e) {
        e.preventDefault();
        e.stopPropagation();

        const data = new FormData(e.target);


        // Remove empty values from form data
        for (const [key, value] of data.entries()) {
            if (!value?.trim()?.length) {
                data.delete(key);
            }
        }

        const searchParams = new URLSearchParams(data);
        const url = new URL(e.target.getAttribute("action") + "?" + searchParams);

        fetchPage(url).then((html) => {
            this.renderHtml(html);
            window.history.pushState({}, "", url);
        });
    }

    /**
     * click listener which revokes invitation and hides revoke button
     * @param e
     */
    onSubmitRevoke(e) {
        e.preventDefault();
        e.stopPropagation();

        const form = e.target;
        const data = new FormData(form);

        console.log("onSubmitRevoke", form, data.get("post_id"));

        fetch(form.getAttribute("action"), {
            method: "POST",
            body: data,
        }).then((res) => {
            if (!res.ok) {
                throw res.json();
            }
            return res.json();
        }).then((res) => {
            console.log("revoke response", res);
            Notifications.showInfo(res.message);

            const row = getParent(form, "tr");
            console.log("revoke row", form, row);
            if (!row) return;

            if (res.html) {
                const html = createElement(res.html);
                const tr = html.querySelector("tr");
                console.log("replace", row, tr);
                row.replaceWith(tr);
            } else {
                row.classList.remove("invitation-row--status-pending");
                row.classList.add("invitation-row--status-revoked");
            }


        }).catch((res) => {
            console.log("revoke error", res);
            if (res.error?.message) {
                Notifications.showError(res.error.message);
            }
        });

    }
}
